import invariant from "tiny-invariant";

import Color from "@mapmycustomers/shared/enum/Color";
import MarkerShape, { knownShapes } from "@mapmycustomers/shared/enum/MarkerShape";

import { themes } from "@app/scene/map/components/pinLegends/utils/themes";
import colorNameToHex from "@app/util/colors/colorNameToHex";

export const DEFAULT_BUCKETS_COUNT = 5;

export const DEFAULT_NO_VALUE_COLOR = colorNameToHex(Color.GREY);
export const DEFAULT_NO_VALUE_SHAPE = MarkerShape.CIRCLE;
export const DEFAULT_ITEMS_SHAPE = MarkerShape.SQUARE;

const blueTheme = themes.find((theme) => theme.name === "blues");
invariant(!!blueTheme, "Missing the default theme");
const colorFn = blueTheme.getColorFn(DEFAULT_BUCKETS_COUNT);

export const NEW_PIN_LEGEND_COLORS = Array.from({ length: DEFAULT_BUCKETS_COUNT }).map(
  (_, index) => ({ color: colorFn(index) })
);

export const NEW_PIN_LEGEND_SHAPES = knownShapes
  .filter((shape) => shape !== DEFAULT_NO_VALUE_SHAPE)
  .slice(0, DEFAULT_BUCKETS_COUNT)
  .map((shape) => ({ shape }));

invariant(
  knownShapes.length - 1 >= DEFAULT_BUCKETS_COUNT,
  "Default buckets count too big: insufficient shapes"
);
